import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { userService } from '../../services/userService';
import TermsAcceptanceModal from '../shared/TermsAcceptanceModal';

export const PrivateRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { currentUser } = useAuth();
  const [termsAccepted, setTermsAccepted] = useState<boolean | null>(null);

  useEffect(() => {
    if (currentUser) {
      userService.getTermsStatus().then((s) => {
        setTermsAccepted(s.accepted);
      }).catch(() => {
        setTermsAccepted(true); // fail open if endpoint errors
      });
    }
  }, [currentUser]);

  if (!currentUser) return <Navigate to="/login" />;
  if (termsAccepted === null) return null; // loading

  return (
    <>
      <TermsAcceptanceModal
        open={!termsAccepted}
        onAccepted={() => setTermsAccepted(true)}
      />
      {children}
    </>
  );
};
